import React,{useEffect,useState} from 'react'
import  diagnostic from "./pspdata/degrees_diagnostic_certainty.json"
import {Table,Form,Col} from 'react-bootstrap'
function AnswerField(props){
   
    let answers = props.answers
    
    const [value,setVal] = useState(answers[0])
    
    useEffect(()=>{
        if(props.data!=null){
            setVal(props.data)
        }
    },[props.data])
    const handleAnswer =  (e) =>{
       setVal(e.target.value)
       
  
        props.handler(e)

    }
    const event_name = props.name
    
        return(
            
        <Form.Group as={Col}>
                
                <Form.Control as={"select"} onChange={handleAnswer} name={event_name} value={value} disabled={props.disabled}>
                        {answers.map((answer,index) =>(
                            <option key={index}>{answer}</option>))}
                </Form.Control>
            </Form.Group>
    
        )
    }

AnswerField.defaultProps ={
    useScore:false,
    data:null
}
function DiagnosticTable(props){
    return(
        <Table>
                   <thead>
                       <tr>
                           <th>Diagnostic Certainty</th>
                           <th>Combinations</th>
                           <th>Abbreviation</th>
                           <th>Presence</th>
                       </tr>
                   </thead>
                   <tbody>
                       { diagnostic.map((d,i)=>(
                           <tr key={i}>
                               <td>{d.diagnostic_certainty}</td>
                               <td>{d.combinations}</td>
                               <td>{d.abb}</td>
                               <td><AnswerField name={d.name} handler={props.handler} data={props.data!=null?props.data[d.name]:null} disabled={props.edit} answers={["","Yes","No"]} /></td>
                           </tr>
                       ))}
                   </tbody>
        </Table>
    )
}
export default DiagnosticTable